import { ADD_MOWING_RECORD, EDIT_MOWING_RECORD, SELECT_MOW_TO_EDIT, DELETE_MOWING_RECORD,
  PREPARE_MOWING_APPLICATION, FETCH_MOWING_APPLICATIONS, SELECT_MOWING_APPLICATION, DELETE_MOWING_APPLICATION,
  SELECT_MOW_APP_TO_EDIT } from './types';
import { ROOT_URL } from '../../constants';
import { fillForm, findEmployeeByName, resetForm, generateID, acresPerHour, acresBalance,
 checkApplicationForm } from '../cult_utils';
import { fetchFields } from './utils_actions';
import { error, success } from './chem_actions';
import axios from 'axios';
const $ = window.$;
/**
* fetchMowingApplications(): Fetches all recent fertilizer applications
* @returns {Array} mowingRecords
* @called-in: ['/components/mowing/mowing_view.js']
**/
export function fetchMowingApplications() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchMowingApplications`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_MOWING_APPLICATIONS, payload: res.data.mowingRecords });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching fertilizer applications.`));
      });
  }
}
/**
* deleteMowingApplication(): Deletes a mowing record
* @param {String} mowAppId: id of mowing application
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_view.js->fab_modal_v2.js']
**/
export function deleteMowingApplication({ mowAppId }) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/deleteMowingApplication`, { mowAppId })
      .then((res) => {
        $('#preloader').css('display','none');
        success(res.data.msg);
        dispatch({ type: DELETE_MOWING_APPLICATION, payload: res.data.mowAppId });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch({type: 'ERROR', payload: err});
      });
  }
}
/**
* createOrEditMowingApplication(): Creates or edits a mowing application
* @param {Object} data: mowing application data
* @param {String} type: Type of action: Create or Edit
* @param {String} path: Path to submit: Create or edit
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/
export function createOrEditMowingApplication({ data, type, path }) {
  if (checkApplicationForm(data)) return error('Entire form must be filled.');
  if (data.mowJobs.length === 0) return error('At least one mow record is required.');
  for (let f of data.mowJobs) if (Number(f.acresBalance) < 0) return error(`Cannot exceed total acres in a field. Off by ${f.acresBalance}`);

  return (dispatch) => {
    axios.post(`${ROOT_URL}/${path}`, { data })
      .then((res) => {
        resetForm('mowing-form');
        let { record, msg } = res.data;
        success(msg);
        dispatch({ type, payload: record });
      }).catch((err) => {
        dispatch({type: 'ERROR', payload: err});
      });
  }
}
/**
* prepareMow(): Prepares a mowing application for submission
* @param {Object} mow: mow record
* @param {String} formId: id of mowing form
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/
export function prepareMow({ user, form, fields, employees, mowJobs, mowAppId, editingApplication }) {
  let e = findEmployeeByName(form.employee, employees);
  let isComplete = form.isComplete === 'Incomplete' ? 0 : 1;
  // If EID is filled in form
  if (!e && form.employee !== '') e = employees.find((emp) => emp.eid === form.employee);

  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPreviousMowApplications`, {
      params: { date: form.date, mowJobs: JSON.stringify(mowJobs), round: form.round, isComplete },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
      let { prevApps } = res.data;

      if (editingApplication) {
        prevApps = prevApps.map((p) => {
          // eslint-disable-next-line
          if (mowJobs.find((m) => m.id === p.id)) return;
          return p;
        }).filter((p) => p !== undefined)
      }
      for (let mow of mowJobs) {
        let field = fields.find((f) => f.field === mow.field);
        let previousAcresWorked = prevApps.filter((p) => p.field === mow.field && p.id !== mow.id)
                                                   .reduce((acc, cur) => { return acc + Number(cur.acresCompleted) },0);
        //if (editingApplication) previousAcresWorked = 0;
        let totalAcresWorked = Number(mow.acresCompleted) + previousAcresWorked;
        let balance = acresBalance(totalAcresWorked, field.totalAcre);
        mow.acresBalance = balance;
      }
      dispatch({
        type: PREPARE_MOWING_APPLICATION,
        payload: {
          ...form,
          employee: e.eid,
          mowAppId: mowAppId ? mowAppId : generateID(),
          isComplete,
          submitter: user.eid,
          mowJobs
        },
        prevApps: prevApps
      });
    }).catch((err) => dispatch(error(`There was an error fetcing previous mows. ${err}`)));
  }
}
/**
* addMow(): Adds a mowing record in the create mow form
* @param {Object} mow: mow record
* @param {String} formId: id of mowing record form
* @returns {Object} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/
export function addMow({ mow, formId }) {
  if (Number(mow.hours) <= 0) return error('Mowing records require hours.');
  resetForm(formId);
  return {
    type: ADD_MOWING_RECORD,
    payload: {
      id: generateID(),
      acresPerHour: acresPerHour(mow.hours, mow.acresCompleted),
      ...mow
    }
  }
}
/**
* editMow(): Edits a mowing record
* @param {Object} mow: mow job
* @param {String} formId: id of form
* @param {String} mowAppId: id of mow application
* @param {Object} editMow: the mowjob object being edited
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/
export function editMow({ mow, mowAppId, editingMow, formId }) {
  if (Number(mow.hours) <= 0) return error('Mowing records require hours.');
  resetForm(formId);
  if (Object.keys(editingMow).length > 0) {
    mow.mowAppId = editingMow.mowAppId;
    mow.id = editingMow.id;
  }
  return {
    type: EDIT_MOWING_RECORD,
    payload: {
      id: mow.id ? mow.id : generateID(),
      acresPerHour: acresPerHour(mow.hours, mow.acresCompleted),
      ...mow
    }
  }
}
/**
* deleteMow(): Deletes a mowing record
* @param {Number} mowId: mowjob id
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js->mowing_form.js']
**/
export function deleteMow({ mow }) {
  return {
    type: DELETE_MOWING_RECORD,
    payload: mow
  }
}
/**
* selectMowToEdit(): Selects a mow record to edit
* @param {Object} mow: mow job
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/
export function selectMowToEdit({ mow, formId }) {
  setTimeout(() => {
    fillForm(formId, mow);
  }, 500)

  return {
    type: SELECT_MOW_TO_EDIT,
    payload: mow
  }
}
/**
* selectMowingApplication(): Sets the application to view or delete
* @param {Object} app: app to view/delete
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_view.js']
**/
export function selectMowingApplication(app) {
  return {
    type: SELECT_MOWING_APPLICATION,
    payload: app
  }
}
/**
* selectMowAppToEdit(): Sets the application to edit
* @param {Object} app: app to edit
* @returns {Array} type, payload
* @called-in: ['/components/mowing/mowing_create.js']
**/
export function selectMowAppToEdit({ formId, app, employees }) {
  let employee = employees.find((e) => e.eid === app.employee);
  if (employee) app.employee = `${employee.firstName} ${employee.lastName}`;
  // Fill form
  fillForm(formId, app);
  // After form is filled, set employee back to eid
  app.employee = employee.eid;
  return (dispatch) => {
    dispatch(fetchFields(app.location));
    dispatch({
      type: SELECT_MOW_APP_TO_EDIT,
      payload: app
    });
  }
}


































/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/mowing_actions.js